/** Download of the 1QA Device Agent, built into the web image (apps/device-agent -> /downloads). */
export const DEVICE_AGENT_DOWNLOAD = '/downloads/1qa-device-agent.zip';
const DEVICE_AGENT_BUILD_INFO = '/downloads/1qa-device-agent.json';

/** release/1qa-device-agent.json, written by apps/device-agent/build.mjs. */
export interface DeviceAgentBuild {
  /** "1.0.0.7": package version + build number; the agent reports the same in its hello. */
  version: string;
  versionName: string;
  build: number;
  builtAt: string;
  commit: string | null;
}

/** The latest build offered for download, or null when unknown (e.g. the Vite dev server has no /downloads). */
export async function fetchLatestDeviceAgent(): Promise<DeviceAgentBuild | null> {
  try {
    const res = await fetch(DEVICE_AGENT_BUILD_INFO, { cache: 'no-cache' });
    if (!res.ok || !res.headers.get('content-type')?.includes('json')) return null;
    const data = (await res.json()) as Partial<DeviceAgentBuild>;
    return typeof data.version === 'string' && typeof data.versionName === 'string' ? (data as DeviceAgentBuild) : null;
  } catch {
    return null;
  }
}

/** "1.0.0.7" -> "1.0.0 build 7" (older agents report just "1.0.0"). */
export const agentVersionName = (v: string) => {
  const p = v.split('.');
  return p.length === 4 ? `${p.slice(0, 3).join('.')} build ${p[3]}` : v;
};

/** File name the download is saved as, with the build in it: "1qa-device-agent-1.0.0.7.zip" (plain name when unknown). */
export const deviceAgentFileName = (build: DeviceAgentBuild | null) => (build ? `1qa-device-agent-${build.version}.zip` : '1qa-device-agent.zip');
